import {GRAPH_COLORS} from '@/appLogic/appConstants/ColorSchema'
import DistributionDS from '@/common/datastructures/DistributionDS'

const MAX_AGE = 99
const BREAKS = [
  {begin: 1, end: 11},
  {begin: 12, end: 17},
  {begin: 18, end: 24},
  {begin: 25, end: 34},
  {begin: 35, end: 49},
  {begin: 50, end: 64},
  {begin: 65, end: MAX_AGE}
]
/**
 * given a list of ages, return the market breaks
 * {
 *  age: the age
 *  value: the Number of that age
 * }
 * @returns [{break, label, value, average}]
 */
const getMarketBreakAverages = function (ages) {
  const marketBreaks = []
  let totalSum = 0
  for (const breaker of BREAKS) {
    const ageBreak = ages.filter(a => a.age >= breaker.begin && a.age <= breaker.end)
    if (ageBreak.length > 0) {
      const sumPeople = sumOfPeople(ageBreak)
      totalSum += sumPeople
      marketBreaks.push({
        break: breaker,
        label: `${breaker.begin} - ${breaker.end}`,
        value: sumPeople
      })
    }
  }
  for (const breaker of marketBreaks) {
    breaker['percentage'] = (breaker.value / totalSum) * 100
  }
  return marketBreaks
}

const sumOfAgeTimesPeople = function (ages) {
  return ages.reduce((acc, val) => {
    if (typeof acc !== 'number') {
      acc = (acc.value * acc.age)
    }
    return acc + (val.age * val.value)
  })
}

const sumOfPeople = function (ages) {
  if (ages.length === 0) {
    return 0
  } else if (ages.length === 1) {
    return ages[0].value
  } else {
    return ages.reduce((acc, val) => {
      if (typeof acc !== 'number') {
        acc = acc.value
      }
      return acc + val.value
    })
  }
}

const getMeanOfAges = function (ages) {
  let totalNumberOfPeople = sumOfPeople(ages)
  let sumOfAges = sumOfAgeTimesPeople(ages)
  let mean = sumOfAges / totalNumberOfPeople
  return parseFloat(Math.round(mean * 100) / 100).toFixed(2)
}

const ageGraphData = function (ages) {
  let data = ages.map(d => d.value)
  // TODO we can add this to the charts to make them percentage central...
  let totalNumberOfPeople = data.reduce((acc, val) => acc + val)
  let percentages = data.map(d => (d / totalNumberOfPeople) * 100)
  // *****DONE******
  let sumOfAges = ages.reduce((acc, val) => {
    if (typeof acc !== 'number') {
      acc = (acc.value * acc.value)
    }
    return acc + (val.age * val.value)
  })
  let meanAge = sumOfAges / totalNumberOfPeople
  let labels = ages.map(d => String(d.age))
  let label = 'Age Distribution'
  return {
    labels,
    datasets: [{
      label,
      data: percentages,
      backgroundColor: GRAPH_COLORS.DARK_BLUE,
      borderColor: GRAPH_COLORS.BORDER_COLOR,
      addMean: {
        mean: meanAge
      }
    }]
  }
}

const marketBreakAveragesGraphData = function (ages) {
  let marketBreakers = getMarketBreakAverages(ages)
  return {
    labels: marketBreakers.map(br => br.label),
    datasets: [{
      label: 'Market Breakers Ages',
      data: marketBreakers.map(br => br.percentage),
      backgroundColor: GRAPH_COLORS.DARK_BLUE,
      hoverBackgroundColor: GRAPH_COLORS.LIGHT_BLUE,
      borderColor: GRAPH_COLORS.BORDER_COLOR
    }]
  }
}

const ageDistributionGraphData = function (ages) {
  let data = ages.map(d => d.value)
  // TODO we can add this to the charts to make them percentage central...
  let sum = data.reduce((acc, val) => acc + val)
  let percentages = data.map(d => (d / sum) * 100)
  // *****DONE******
  let ds = new DistributionDS(percentages, ages.map(d => String(d.age)), 10)
  let label = 'Age Distribution'
  return ds.getDistribution(label, {
    backgroundColor: GRAPH_COLORS.DARK_BLUE,
    hoverBackgroundColor: GRAPH_COLORS.LIGHT_BLUE,
    borderColor: GRAPH_COLORS.BORDER_COLOR
  })
}

export {
  sumOfAgeTimesPeople,
  sumOfPeople,
  getMeanOfAges,
  marketBreakAveragesGraphData,
  ageDistributionGraphData,
  ageGraphData
}



// WEBPACK FOOTER //
// ./src/app/appLogic/marketBreaks/AgeMarketBreaks.js